<div class="grid p-3 gap-3">
    <div class="col-12">
        <app-incident-list [display]="'inline'"></app-incident-list>
    </div>
    <div class="col-12">
        <app-task-list [display]="'inline'"></app-task-list>
    </div>
    <div class="col-12 xl:col">
        <app-approval-list [display]="'inline'"></app-approval-list>
    </div>
    <div class="col-12 xl:col">
        <app-notification-list [display]="'inline'"></app-notification-list>
    </div>
</div>